import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';
import { CROP_AREA_COLOR } from './cropAreaColor';

/** Philippines rice area. Classes 1 and 2 are rice; 0 is not rice. */
export const RICE_CROP_COG_URL =
  'https://digisaka.s3.amazonaws.com/crop_area/philippines_rice_area_2021_native_cog.tif';

/** Raster extent from TiTiler /info (EPSG:4326). */
export const RICE_CROP_BBOX: [number, number, number, number] = [
  116.0, 3.9993, 128.0001, 22.0028,
];

const TITILER_TILE_BASE = DIGISAKA_API_ORIGIN + '/api/tiles/WebMercatorQuad/{z}/{x}/{y}@2x.png';

export const RICE_CROP_COLOR = CROP_AREA_COLOR;

export const RICE_CROP_LEGEND = {
  colors: [RICE_CROP_COLOR],
  labels: ['Rice'],
  description: 'Rice areas',
};

export function buildRiceCropTileUrl(cogUrl: string = RICE_CROP_COG_URL): string {
  const params = new URLSearchParams();
  params.set('url', cogUrl);
  params.set('bidx', '1');
  params.set('colormap', JSON.stringify({ '1': RICE_CROP_COLOR, '2': RICE_CROP_COLOR }));
  params.set('nodata', '0');
  params.set('resampling', 'nearest');
  return `${TITILER_TILE_BASE}?${params.toString()}`;
}
